module.exports = __webpack_public_path__ + "static/img/Angus-Crichton.fd31c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Angus-Crichton.jpg
// module id = 1UvT
// module chunks = 0